import React from 'react';
import { Droppable } from './droppable';
import Task from './common/Task';

const Grid = ({ effortLevels, impactLevels, gridTasks, handleDelete, handleComplete }) => {
    return (
        <div className='flex-1 flex flex-col border border-gray-300'>
            {effortLevels.map((effort, effortIndex) => (
                <div key={effort} className='flex flex-1 border-b border-gray-300'>
                    <div className='w-24 flex items-center justify-center border-r border-gray-300 bg-orange-200'>
                        <span>{effort}</span>
                    </div>
                    <div className='flex-1 grid grid-cols-3 gap-2'>
                        {impactLevels.map((impact) => (
                            <Droppable key={`${effort}_${impact}`} id={`${effort}_${impact}`}>
                                <div className="h-full border z-1 border-gray-300 p-2 rounded bg-green-50 overflow-hidden">
                                    <div className="text-xs text-gray-500 mb-2">{`${effort} ${impact}`}</div>
                                    {gridTasks?.filter(task => task.priority === effort && task.impact === impact)
                                        ?.map((task) => (
                                            <Task
                                                key={task.task_id}
                                                task={task}
                                                onDelete={handleDelete}
                                                onComplete={handleComplete}
                                            />
                                        ))
                                    }
                                </div>
                            </Droppable>
                        ))}
                    </div>
                </div>
            ))}
            <div className='flex  border-t border-gray-300'>
                <div className='w-24'></div>
                <div className='flex-1 grid grid-cols-3 gap-2'>
                    {impactLevels.map((impact) => (
                        <div key={impact} className='flex justify-center'>
                            <span>{impact}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className='flex justify-center mt-2'>
                <span className='text-xl font-bold'>Impact</span>
            </div>
        </div>
    );
};

export default Grid;